import { NgModule } from '@angular/core';
import { ApiModule } from './api/api.module';
import { ConfigModule } from './config/config.module';
import { ValidatorModule } from 'core/validator/validator.module';

@NgModule({
  imports: [
    ApiModule,
    ConfigModule,
    ValidatorModule
  ]
})
export class CoreModule { }
